export default __webpack_public_path__ + "static/media/ecran.dbe17c26.png";